import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/ticket',
    name: 'ticket',
    component: () => import(/* webpackChunkName: "ticket" */ '../views/ticket/route.vue'),
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import(/* webpackChunkName: "ticket" */ '../views/ticket/home.vue')
      },{
        path: 'test',
        name: 'test',
        component: () => import(/* webpackChunkName: "ticket" */ '../views/ticket/test.vue')
      },
      {
        path: 'reservation',
        name: 'reservation',
        component: () => import(/* webpackChunkName: "ticket_reservation" */ '../views/ticket/reservation.vue')
      },
      {
        path: 'groupDetail',
        name: 'groupDetail',
        component: () => import(/* webpackChunkName: "ticket_group" */ '../views/ticket/groupDetail.vue')
      },
      {
        path: 'groupCode',
        name: 'groupCode',
        component: () => import(/* webpackChunkName: "ticket_group" */ '../views/ticket/groupCode.vue')
      },
      {
        path: 're_success',
        name: 'reSuccess',
        component: () => import(/* webpackChunkName: "ticket_reservation" */ '../views/ticket/re_success.vue')
      },
      {
        path: 'orders',
        name: 'orders',
        component: () => import(/* webpackChunkName: "ticket_order" */ '../views/ticket/orders.vue')
      },{
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import(/* webpackChunkName: "ticket_order" */ '../views/ticket/orderDetail.vue')
      },{
        path: 'orderCheck',
        name: 'orderCheck',
        component: () => import(/* webpackChunkName: "ticket_order" */ '../views/ticket/orderCheck.vue')
      },{
        path: 'success',
        name: 'success',
        component: () => import(/* webpackChunkName: "ticket_order" */ '../views/ticket/success.vue')
      },{
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "ticket_login" */ '../views/ticket/login.vue')
      },{
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "ticket_login" */ '../views/ticket/register.vue')
      },{
        path: 'writeOffMuseum',
        name: 'writeOffMuseum',
        component: () => import(/* webpackChunkName: "ticket_login" */ '../views/ticket/writeOffMuseum.vue')
      },{
        path: 'writeOffPersonal',
        name: 'writeOffPersonal',
        component: () => import(/* webpackChunkName: "ticket_login" */ '../views/ticket/writeOffPersonal.vue')
      },{
        path: 'venueList',
        name: 'venueList',
        component: () => import(/* webpackChunkName: "ticket" */ '../views/ticket/venueList.vue')
      },{
        path: 'msb',
        name: 'msb',
        component: () => import(/* webpackChunkName: "ticket" */ '../views/ticket/msb.vue')
      },{
        path: 'personalCenter',
        name: 'personalCenter',
        component: () => import(/* webpackChunkName: "ticket" */ '../views/ticket/personalCenter.vue')
      },{
        path: 'ordersNew',
        name: 'ordersNew',
        component: () => import(/* webpackChunkName: "ticket" */ '../views/ticket/ordersNew.vue')
      }
    ]
  },
  
  // {
  //   path: '/ticket/home',
  //   name: 'reservation',
  //   component: () => import(/* webpackChunkName: "ticket" */ '../views/ticket/reservation.vue')
  // }
]

const router = new VueRouter({
  routes
})

export default router
